import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IChingComponent } from '../jckpi37/i-ching.component';
import { jkBaseForm } from 'jk-service';
import { TitlebarComponent } from 'jk-service';

@Component({
  selector: 'app-jckpi38',
  standalone: true,
  imports: [IChingComponent,TitlebarComponent,],
  templateUrl: './jckpi38.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jckpi38.component.css'
})
export class Jckpi38Component  extends jkBaseForm implements OnInit {
  override _programId = 'jckpi38'; // ### 易經占卜

}
